import { CoreSkeletonWrapper } from "@verity/components/core";

/**
 * Placeholder for the whole result view, used at the two points where nothing more specific can be
 * drawn yet:
 *
 * - `ProctoringResultView` itself, while `isAssessmentTypeLoading` — the LMS and Verity layouts differ
 *   enough that picking one and swapping it out reads as badly as a wrong layout, so neither is
 *   committed to until the assessment type is known.
 * - `TestTakerResultModal`, while its own assessment/session reads are still in flight and it has
 *   nothing to mount the view with.
 *
 * Deliberately one plain box rather than a sketch of either layout: the two share only their coarse
 * shell, and anything more detailed would be a guess at which one is coming. Both callers render the
 * same thing, so the handover between them is invisible.
 *
 * Lives in its own file because both of those callers need it and `TestTakerResultModal` imports
 * `ProctoringResultView` — defining it in either would make the import cycle.
 */
export default function NeutralResultViewSkeleton() {
	return (
		<div style={{ width: "100%", minHeight: "100%", padding: "12px", boxSizing: "border-box" }}>
			{/* Animation is CoreSkeletonWrapper's own default (wave), matching every other skeleton on the page. */}
			<CoreSkeletonWrapper loading width="100%" height="90vh">
				<div />
			</CoreSkeletonWrapper>
		</div>
	);
}
